import React from 'react'
import {Routes, Route} from 'react-router-dom'
import Home from '../Pages/Home';
import Error404 from '../Pages/404';
import Contact from '../Pages/Contact';
import Gallery from './Gallery/Gallery';
import Profile from './Profile/Profile';




const Layout = () => {
  return (
    <>
    <Routes>
        {/* <Route path ='/' element = {<Navigate to = '/home'/>}/> */}
        <Route index path = '/' element = {<Home/>}/>
        <Route path='/gallery' element={<Gallery/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/profile' element = {<Profile/>}/>
        <Route path='*' element={<Error404/>}/>
    </Routes>
    </>
  )
}

export default Layout